import React from 'react'
import { isDevelopment } from 'services/environment'

export interface IEventPropagationBlockerProps {
  component?: any
  children: React.ReactNode
}

/**
 * This component will block event propagation from its children to its parent
 */
function EventPropagationBlocker({ children, component = 'div' }: IEventPropagationBlockerProps) {
  // Make sure there is exactly one child passed
  // This will cause a crash, but only in dev (prevent useless crashes in prod)
  if (isDevelopment()) React.Children.only(children)

  const eventNames = ['onClick', 'onMouseDown', 'onMouseUp']
  const stopPropagation = (event: React.SyntheticEvent) => {
    event?.stopPropagation()
  }

  const innerProps = Object.fromEntries(eventNames.map(eventName => [eventName, stopPropagation]))
  const Component = component

  return (
    <Component {...innerProps}>
      {children}
    </Component>
  )
}

export default React.memo(EventPropagationBlocker)
